import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-780bee17"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "my-page" }
const _hoisted_2 = { class: "my-page__body" }


export default /*#__PURE__*/_defineComponent({
  __name: 'MyPage',
  props: {
    onClose: null
  },
  setup(__props: any) {

const props = __props as { onClose?: () => void }



return (_ctx: any,_cache: any) => {
  const _component_a_empty = _resolveComponent("a-empty")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_a_empty, { description: "页面开发中" }),
      _createTextVNode(" hello ")
    ])
  ]))
}
}

})